/**
 * @module store/admin/system-variables/actions
 */

/**
 * Method to get the system variables that are used by the UI.
 * @returns {array} Array of the variables that are to be used in the UI.
 */
export async function getFront({ commit, rootState }) {
  const response = await this.$axios.$get('/api/systemvariables/front', {
    params: { _t: rootState.LAST_UPDATE_TIMESTAMPS['apiSystemvariablesFront'] }
  });

  commit('setSystemVariableList', {
    list: response,
    variableMap: (response || []).reduce(
      (acc, variable) => ({ ...acc, [variable.Key.toLowerCase()]: variable.Value }),
      {}
    )
  });
}
